__turbopack_context__.v({
  "bottomSheet": "j9J1Ta_bottomSheet",
  "merchSizing": "j9J1Ta_merchSizing",
  "root": "j9J1Ta_root",
});
